import { createContext, useContext, useMemo, type ReactNode } from 'react'

import { useAuth } from '../auth/AuthContext'
import type { AppConfig } from '../config'
import { ApiClient } from './client'

const ApiContext = createContext<ApiClient | null>(null)

export function ApiProvider(props: { config: AppConfig; children: ReactNode }) {
  const { getAccessToken, refreshAccessToken, signOut, reportSuspension } = useAuth()
  const client = useMemo(
    () => new ApiClient(props.config, { getAccessToken, refreshAccessToken, signOut, reportSuspension }),
    [props.config, getAccessToken, refreshAccessToken, signOut, reportSuspension],
  )
  return <ApiContext.Provider value={client}>{props.children}</ApiContext.Provider>
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext)
  if (!client) throw new Error('useApi must be used inside ApiProvider')
  return client
}
